export default class Wish {
  id!: string;
  title!: string;
  description!: string;
  image!: string | null;
  commentCount!: number;
  reservertions!: number;
}
